import { OptionsService } from '@/services/options';
import type { IOptionsService } from '@/services/options';

export const optionsService: IOptionsService = new OptionsService(window.__flippingbook_login__);
